import { WebSocketActionTypes } from './../actions/websockets.actions';

/**
 * Les composants ne lisent que le dernier message reçu. Conserver tout
 * l'historique faisait croître l'état sans limite sur une session d'examen.
 */
const MAX_STORED_MESSAGES = 50;

export interface WebSocketState {
    connected: boolean;
    reconnectionFailed: boolean;
    messages: any[];
}

const initialState: WebSocketState = {
    connected: false,
    reconnectionFailed: false,
    messages: []
};

export function webSocketReducer(state = initialState, action: any): WebSocketState {
    switch (action.type) {
        case WebSocketActionTypes.Connect:
            return { ...state };
        case WebSocketActionTypes.Disconnect:
            return { ...state };
        case WebSocketActionTypes.ConnectionStatusChanged:
            return {
                ...state,
                connected: action.connected,
                reconnectionFailed: action.connected ? false : state.reconnectionFailed
            };
        case WebSocketActionTypes.ReconnectionFailed:
            return { ...state, connected: false, reconnectionFailed: true };
        case WebSocketActionTypes.ReceiveMessage:
            return { ...state, messages: [...state.messages, action.message].slice(-MAX_STORED_MESSAGES) };
        default:
            return state;
    }
}
